import { Box } from "@mui/material"
import type { FC } from "react"

import { FilePreview } from "@/components/upload/SingleFileUpload"
import type { SignedUrl } from "@/graphql/codegen/graphql"

interface TransferDocumentItemProps {
  document: SignedUrl
  onDelete: (document: SignedUrl) => void
  readOnly?: boolean
}

export const TransferDocumentItem: FC<TransferDocumentItemProps> = ({ document, onDelete, readOnly = false }) => {
  const handleView = () => {
    window.open(document.url, "_blank")
  }

  const handleDelete = () => {
    onDelete(document)
  }

  return (
    <Box className='w-full cursor-pointer rounded border border-gray-400' onClick={handleView}>
      <FilePreview
        file={document.file ?? null}
        readOnly={readOnly}
        onRemove={handleDelete}
        data-testid='transfer.document-item.preview'
      />
    </Box>
  )
}
